import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MmButtonModule } from '@metromarkets/components';

import { NewsletterLandingRoutingModule } from './newsletter-landing-routing.module';
import { NewsletterLandingComponent } from './components/newsletter-landing.component';

@NgModule({
  declarations: [NewsletterLandingComponent],
  imports: [
    CommonModule,
    NewsletterLandingRoutingModule,
    MmButtonModule,
    TranslateModule,
  ],
})
export class NewsletterLandingModule {}
